export function buttonize(fn) {
  return {
    role: 'button',
    onClick: fn,
    onKeyDown: (e) => {
      if (e.key === 'Enter') {
        fn(e);
      }
    },
  };
}
